import { render } from "./ShippingRates.vue?vue&type=template&id=a6962c42"
import script from "./ShippingRates.vue?vue&type=script&lang=js"
export * from "./ShippingRates.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__